export default {
  getters: {
    chatDialogs: (state, getters) =>
      getters['entities/chatDialogs/query']()
        .with('messages')
        .orderBy('timestamp', 'desc')
        .get(),

    currentChatDialog: (state, getters, rootState) =>
      getters['entities/chatDialogs/query']()
        .with('messages', query => {
          query.orderBy('timestamp', 'desc')
        })
        .where('id', rootState.route.params.dialogId)
        .first()
  },
  actions: {
    storeDialogAsRead({ dispatch }, id) {
      dispatch('entities/chatDialogs/update', {
        where: id,
        data: { read: true }
      })
    }
  }
}
